// extracted by mini-css-extract-plugin
export default {"benefits":"Benefits_benefits__+sntz","content":"Benefits_content__8X7mr","card":"Benefits_card__icCvX","arrowbtn":"Benefits_arrowbtn__982g1"};